import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["badge"]

  connect() {
    this.updateBadgeVisibility()
  }

  disconnect() {
  }

  // Método para actualizar la visibilidad del badge después de actualizaciones de Turbo Streams
  updateBadgeVisibility() {
    const badge = document.getElementById('chat_unread_badge')
    if (badge) {
      const count = parseInt(badge.textContent.trim()) || 0
      if (count > 0) {
        badge.classList.remove('d-none')
      } else {
        badge.classList.add('d-none')
      }
    }
  }

  // Método que puede ser llamado cuando se recibe una actualización
  refresh() {
    // Turbo Streams manejará la actualización del DOM
    // Este método puede ser útil para lógica adicional si es necesario
    setTimeout(() => {
      this.updateBadgeVisibility()
    }, 100)
  }
}
